import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: '/', name: 'Home', component: Home },
  { path: '/about', name: 'About', component: () => import('../views/About.vue') },
  { path: '/services', name: 'Services', component: () => import('../views/Services.vue') },
  { path: '/contact', name: 'Contact', component: () => import('../views/Contact.vue') },
  { path: '/work', name: 'Work', component: () => import('../views/Work.vue') },
  { path: '/work/we-power', name: 'WePower x URBNRX', component: () => import('../views/work/WePower.vue') },
  {
    path: '/work/health-and-human-services-committee-briefing',
    name: 'Health and Human Services Committee Briefing',
    component: () => import('../views/work/HealthAndHumanServicesCommitteeBriefing.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
